/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Alert from "./Alert";
import BaseCom from "./BaseCom";
import Card from "./Card";
import FormInput from "./FormInput";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";
import { qreq } from "../shared/qrequest";

class SetPassword extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            creds: {
                firstName: '',
                code: props.params.code,
                loaded: false,
                submitting: false
            }
        };
        this.setUser = props.setUser;
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        qreq.post('/api/auth/reset-password/check', this.state.creds, j => {
            if (j.errorCode !== 0) {
                this.alert(j.errorMessage)
                this.props.navigate('/login');
            }
            else if (j.item) {
                this.setState({ firstName: j.item.firstName, loaded: true });
            }
        }, e => {
            this.alert('An unknown error has ocurred.');
            this.props.navigate('/login');
        });
    }

    onSubmit(e) {
        e.preventDefault();

        if (this.state.creds.password.length < 6) {
            this.alert('Passwords must be at least 6 characters long.');
            return;
        }

        if (this.state.creds.password !== this.state.creds.confirmPassword) {
            this.alert('Passwords do not match.');
            return;
        }

        this.setState({ submitting: true });

        qreq.post('/api/auth/reset-password', this.state.creds, j => {
            if (j.errorCode !== 0)
                this.alert(j.errorMessage)
            else if (j.item) {
                this.setUser(j.item);
                this.props.navigate('/dashboard');
            }
            this.setState({ submitting: false });
        }, e => {
            this.alert('An unknown error has ocurred.');
            this.setState({ submitting: false });
        });
    }

    render() {
        return <div className="container">
            <div className="bg-white p-4 rounded-3">
                <img src="/img/logo-d.png" alt="" className="img-fluid w-50 d-block mx-auto" />
            </div>
            {this.state.loaded ?
                <Card title="Set Password">
                    <p className="mb-2">Hello <strong>{this.state.firstName}</strong>. Please set your password below.</p>
                    <form onSubmit={this.onSubmit}>
                        <FormInput model={this.state.creds} name="password" label="New Password" type="password" required autoComplete="new-password" />
                        <FormInput model={this.state.creds} name="confirmPassword" label="Confirm New Password" type="password" required autoComplete="new-password" />
                        {this.state.submitting ? <Alert message="Please wait..." /> : <div className="btn-group">
                            <button type="submit" className="btn btn-primary">Set Password</button>
                            <button type="button" className="btn btn-secondary" onClick={() => this.props.navigate('/login')}>Cancel and go to login</button>
                        </div>}
                    </form>
                </Card> : <LoadingAlert />}
        </div>;
    }
}

export default withParamsAndNavigate(SetPassword);